import { createReducer, on } from '@ngrx/store';

import { Logout, LoadingState } from '@personal-area/global/state';

import * as identityAction from '../actions/identity';

export interface IdentityState {
  flow: {
    type: 'manual' | 'auto';
    accessToken: string;
    countryCode: string;
    loadingState: LoadingState;
  };
  request: {
    rejectReason: string;
    loadingState: LoadingState;
  };
}

const initialState: IdentityState = {
  flow: {
    type: 'manual',
    accessToken: '',
    countryCode: '',
    loadingState: LoadingState.initial,
  },
  request: {
    rejectReason: '',
    loadingState: LoadingState.initial,
  },
};

export const identityReducer = createReducer(
  initialState,
  on(identityAction.GetIdentityFlow, (state) => ({
    ...state,
    flow: {
      ...state.flow,
      loadingState: LoadingState.loading,
    },
  })),
  on(identityAction.GetIdentityFlowSuccess, (state, { settings }) => ({
    ...state,
    flow: {
      type: settings.type,
      accessToken: settings.auto?.accessToken ?? '',
      countryCode: settings.auto?.countryCode ?? '',
      loadingState: LoadingState.loaded,
    },
  })),
  on(identityAction.GetIdentityFlowFail, (state) => ({
    ...state,
    flow: {
      ...initialState.flow,
      loadingState: LoadingState.failed,
    },
  })),
  on(identityAction.GetRequest, (state) => ({
    ...state,
    request: {
      ...state.request,
      loadingState: LoadingState.loading,
    },
  })),
  on(identityAction.GetRequestSuccess, (state, {rejectReason}) => ({
    ...state,
    request: {
      rejectReason,
      status,
      loadingState: LoadingState.loaded,
    },
  })),
  on(identityAction.GetRequestFail, (state) => ({
    ...state,
    request: {
      ...initialState.request,
      loadingState: LoadingState.failed,
    },
  })),
  on(Logout, state => initialState),
);
